import { UserIdentity } from './identity/user-identity';
import { SiteContextService } from './site-context.service';
import { IdentityService } from './identity/identity.service';
import { Logger, LoggerFactory } from './logger.service';
import { Subscription } from 'rxjs';
import { EventEmitter, Injectable, OnDestroy } from '@angular/core';

export class UserContext {
  public readonly isAdmin: boolean;
  public readonly isSiteAdmin: boolean;
  public readonly hasCurrentSite: boolean;
  public readonly hasIdentity: boolean;

  constructor(
    public identity: UserIdentity,
    public siteId: number | undefined,
  ) {
    this.isAdmin = identity && identity.isAdmin();
    this.hasCurrentSite = this.siteId !== undefined && this.siteId !== 0;
    this.isSiteAdmin = identity && this.hasCurrentSite && identity.isSiteAdmin;
    this.hasIdentity = identity !== undefined;
  }
}

//  Façade class for identityService and siteContextService
@Injectable()
export class UserSession implements OnDestroy {
  public onContextChanged = new EventEmitter<UserContext>();
  public context: UserContext;

  public readonly logger: Logger;
  private identityListener: Subscription;
  private siteIdListener: Subscription;
  private subscriptionArray: Subscription[] = [];

  constructor(
    public readonly identityContext: IdentityService,
    public readonly siteContext: SiteContextService,
    loggerFactory: LoggerFactory,
  ) {
    this.logger = loggerFactory.get('UserSessionService');

    // Listen to session events
    this.identityListener = this.identityContext.onIdentityChanged.subscribe(
      async () => await this.updateContextAsync(),
    );
    this.siteIdListener = this.siteContext.onCurrentSiteChanged.subscribe(async () => await this.updateContextAsync());
    this.updateContextAsync();
  }

  private async updateContextAsync(): Promise<void> {
    // Update context
    const currentSite = await this.siteContext.getCurrentSiteAsync();
    const context = new UserContext(this.identityContext.currentIdentity, currentSite ? currentSite.id : undefined);
    if (context !== this.context) {
      this.context = context;
      this.onContextChanged.emit(context);
    }
  }

  ngOnDestroy(): void {
    this.subscriptionArray.push(this.identityListener, this.siteIdListener);
    this.subscriptionArray.forEach((subs) => subs && subs.unsubscribe());
  }
}
